import { PromotionTemplate } from "../api/promotions.api";
import { aspectRatioToInteger } from "./aspectRatioToInteger";
import { PromotionAspect } from "./getPromotionImageSize";

// returns set aspect ratios for template options
export const getTemplateAspectRatio = (template: PromotionTemplate): number => {
  switch (template) {
    default:
    case PromotionTemplate.Small: {
      return aspectRatioToInteger(PromotionAspect.Small);
    }
    case PromotionTemplate.Large: {
      return aspectRatioToInteger(PromotionAspect.Large);
    }
  }
};